/**
 * Everything the editor admits it does not do yet, in one place.
 *
 * WHY THIS FILE EXISTS, and it is not tidiness. On 2026-10-05 four separate menu entries and
 * eleven rows of the landing page were found saying "Not built yet" about features that had
 * SHIPPED -- page setup, page orientation, cell borders, column widths. Every one of them was a
 * reason written while the feature was planned and left behind when it was built, and every error
 * was in the same direction: claiming less than the product does. That direction is the quiet one.
 * Nobody files a bug because a menu undersells, so it survives indefinitely.
 *
 * Scattered through three files these were invisible. Gathered here they are a page somebody can
 * read in thirty seconds and ask, of each one, "is that still true?" -- which is the only check
 * that actually works, because no test can tell whether a feature works by reading a string.
 *
 * `test_unbuilt_claims_live_here` keeps them gathered: the literal "Not built yet" may not appear
 * anywhere else under components/Docs.
 *
 * TWO KINDS OF CLAIM, AND THE DIFFERENCE MATTERS TO A READER. "Not built yet" means we intend to
 * and have not; "ParkourAI Docs does not do this" means we looked at it and decided against, and the
 * reason is part of the claim. Leaving a decided-against feature sitting under "not built yet" is
 * its own small dishonesty -- it implies a queue the thing is not in.
 *
 * THE RULE FOR ADDING ONE. Say what is missing and WHY, in the terms of this product -- not
 * "coming soon", which tells a reader nothing and ages badly. Say nothing about when.
 *
 * THE RULE FOR REMOVING ONE. Delete it the moment the feature ships, in the same commit. Four of
 * these outlived their features before this file existed, and column types -- which had two
 * entries, one for the menu and one for the panel -- were deleted from here the day they shipped,
 * which is the habit this file is for.
 */

/** A different header and footer on left-hand and right-hand pages. */
export const ODD_EVEN_PAGES = "ParkourAI Docs does not do this, and it is a decision rather than a "
    + "gap: different odd and even pages means a SECOND header and footer in the document — their "
    + "own content, not a mirrored copy — which changes what a document IS rather than adding a "
    + "setting to it. That is a large change to the model for a printing convention nobody has "
    + "asked for.";
